import { IApplicationState } from '../../types/redux';

export const getName = (state: IApplicationState): string | null => {
  return state.newQuestion.name;
};
